import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";

import MenuItemsRenderer from "./Renderer/MenuItemsRenderer";
const MenuItemsForm = lazyLoad(() => import("./Form"));

const menuItemsPlugin = (settings) =>
    createPlugin({
        Renderer: MenuItemsRenderer,
        Controls: MenuItemsForm,

        ...settings,
    });

const menuItems = menuItemsPlugin();
export default menuItems;

export { menuItemsPlugin, MenuItemsRenderer };
